import { CommissionsRecordingType } from '../server/mpsklad_core/Entity/Base/CommissionsRecordingType'

export const commissionsRecordingTypeNames: {
  readonly [K in CommissionsRecordingType]: string
} = {
  [CommissionsRecordingType.Nothing]: 'Не учитывать',
  [CommissionsRecordingType.Commission]: 'Учитывать'
}